export const GET_EXCO_DOCUMENT = "GET_EXCO_DOCUMENT";
export const GET_EXCO_DOCUMENT_SUCCESS = "GET_EXCO_DOCUMENT_SUCCESS";
export const GET_EXCO_DOCUMENT_FAIL = "GET_EXCO_DOCUMENT_FAIL";

export const UPLOAD_DOCUMENT = "UPLOAD_DOCUMENT";
export const UPLOAD_DOCUMENT_SUCCESS = "UPLOAD_DOCUMENT_SUCCESS";
export const UPLOAD_DOCUMENT_FAIL = "UPLOAD_DOCUMENT_FAIL";

export const DELETE_DOCUMENT = "DELETE_DOCUMENT";
export const DELETE_DOCUMENT_SUCCESS = "DELETE_DOCUMENT_SUCCESS";
export const DELETE_DOCUMENT_FAIL = "DELETE_DOCUMENT_FAIL";

export const DOWNLOAD_DOCUMENT = "DOWNLOAD_DOCUMENT";
export const DOWNLOAD_SUCCESS = "DOWNLOAD_SUCCESS";
export const DOWNLOAD_FAIL = "DOWNLOAD_FAIL";

export const GET_PROVINSI = "GET_PROVINSI";
export const GET_PROVINSI_SUCCESS = "GET_PROVINSI_SUCCESS";
export const GET_PROVINSI_FAIL = "GET_PROVINSI_FAIL";

export const GET_KABKOT = "GET_KABKOT";
export const GET_KABKOT_SUCCESS = "GET_KABKOT_SUCCESS";
export const GET_KABKOT_FAIL = "GET_KABKOT_FAIL";

export const GET_KECAMATAN = "GET_KECAMATAN";
export const GET_KECAMATAN_SUCCESS = "GET_KECAMATAN_SUCCESS";
export const GET_KECAMATAN_FAIL = "GET_KECAMATAN_FAIL";

export const GET_KELURAHAN = "GET_KELURAHAN";
export const GET_KELURAHAN_SUCCESS = "GET_KELURAHAN_SUCCESS";
export const GET_KELURAHAN_FAIL = "GET_KELURAHAN_FAIL";

export const GET_TINGKAT_EXCO = "GET_TINGKAT_EXCO";
export const GET_TINGKAT_EXCO_SUCCESS = "GET_TINGKAT_EXCO_SUCCESS";
export const GET_TINGKAT_EXCO_FAIL = "GET_TINGKAT_EXCO_FAIL";

export const GET_JABATAN = "GET_JABATAN";
export const GET_JABATAN_SUCCESS = "GET_JABATAN_SUCCESS";
export const GET_JABATAN_FAIL = "GET_JABATAN_FAIL";

export const GET_PROFILE = "GET_PROFILE";
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
export const GET_PROFILE_FAIL = "GET_PROFILE_FAIL";

export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_FAIL = "UPDATE_PASSWORD_FAIL";

export const UPDATE_PHONENUMBER = "UPDATE_PHONENUMBER";
export const UPDATE_PHONENUMBER_SUCCESS = "UPDATE_PHONENUMBER_SUCCESS";
export const UPDATE_PHONENUMBER_FAIL = "UPDATE_PHONENUMBER_FAIL";

export const GET_ANGGOTA = "GET_ANGGOTA";
export const GET_ANGGOTA_SUCCESS = "GET_ANGGOTA_SUCCESS";
export const GET_ANGGOTA_FAIL = "GET_ANGGOTA_FAIL";

export const GET_BANK = "GET_BANK";
export const GET_BANK_SUCCESS = "GET_BANK_SUCCESS";
export const GET_BANK_FAIL = "GET_BANK_FAIL";

export const UPLOAD_DOCUMENT_PENGURUS = "UPLOAD_DOCUMENT_PENGURUS";
export const UPLOAD_DOCUMENT_PENGURUS_SUCCESS = "UPLOAD_DOCUMENT_PENGURUS_SUCCESS";
export const UPLOAD_DOCUMENT_PENGURUS_FAIL = "UPLOAD_DOCUMENT_PENGURUS_FAIL";

export const DELETE_DOCUMENT_PENGURUS = "DELETE_DOCUMENT_PENGURUS";
export const DELETE_DOCUMENT_PENGURUS_SUCCESS = "DELETE_DOCUMENT_PENGURUS_SUCCESS";
export const DELETE_DOCUMENT_PENGURUS_FAIL = "DELETE_DOCUMENT_PENGURUS_FAIL";

export const DOWNLOAD_DOCUMENT_PENGURUS = "DOWNLOAD_DOCUMENT_PENGURUS";
export const DOWNLOAD_DOCUMENT_PENGURUS_SUCCESS = "DOWNLOAD_DOCUMENT_PENGURUS_SUCCESS";
export const DOWNLOAD_DOCUMENT_PENGURUS_FAIL = "DOWNLOAD_DOCUMENT_PENGURUS_FAIL";

export const LIST_HISTORY_DOCUMENT = "LIST_HISTORY_DOCUMENT";
export const LIST_HISTORY_DOCUMENT_SUCCESS = "LIST_HISTORY_DOCUMENT_SUCCESS";
export const LIST_HISTORY_DOCUMENT_FAIL = "LIST_HISTORY_DOCUMENT_FAIL";

export const DOWNLOAD_HISTORY_DOCUMENT = "DOWNLOAD_HISTORY_DOCUMENT";
export const DOWNLOAD_HISTORY_DOCUMENT_SUCCESS = "DOWNLOAD_HISTORY_DOCUMENT_SUCCESS";
export const DOWNLOAD_HISTORY_DOCUMENT_FAIL = "DOWNLOAD_HISTORY_DOCUMENT_FAIL";

export const GET_CATATAN = "GET_CATATAN";
export const GET_CATATAN_SUCCESS = "GET_CATATAN_SUCCESS";
export const GET_CATATAN_FAIL = "GET_CATATAN_FAIL";

export const GET_KOMISARIS_BASIS = "GET_KOMISARIS_BASIS";
export const GET_KOMISARIS_BASIS_SUCCESS = "GET_KOMISARIS_BASIS_SUCCESS";
export const GET_KOMISARIS_BASIS_FAIL = "GET_KOMISARIS_BASIS_FAIL";
